import { createFileRoute, Link } from "@tanstack/react-router";
import { ExternalUrls } from "../lib/constants";
import { Box, Container, Typography, Button, Stack } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import LoginIcon from "@mui/icons-material/Login";
import HomeIcon from "@mui/icons-material/Home";
import { AnimatedBackground } from "../components/ui/AnimatedBackground";

export const Route = createFileRoute("/401")({
  component: UnauthorizedPage,
});

function UnauthorizedPage() {
  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <AnimatedBackground nodeCount={30} opacity={0.4} />
      <Container maxWidth="sm" sx={{ position: "relative", zIndex: 1 }}>
        <Box sx={{ textAlign: "center", py: 8 }}>
          <Box
            sx={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              bgcolor: "primary.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mx: "auto",
              mb: 3,
            }}
          >
            <LockIcon sx={{ fontSize: 40, color: "white" }} />
          </Box>
          <Typography variant="h2" sx={{ mb: 2 }}>
            Access Denied
          </Typography>
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 4, maxWidth: 400, mx: "auto" }}
          >
            You don't have permission to access this page. Please sign in with
            an authorized account or contact support if you believe this is an
            error.
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
          >
            <Button
              variant="contained"
              size="large"
              component="a"
              href={`${ExternalUrls.dashboard}/login`}
              startIcon={<LoginIcon />}
            >
              Sign In
            </Button>
            <Button
              variant="outlined"
              size="large"
              component={Link}
              to="/"
              startIcon={<HomeIcon />}
            >
              Back to Home
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
